import * as types from "./types";

const initialState = {
  list: [],
  meta: {
    currentPage: 1,
    count: 0,
    pages: 1,
  },
  current: null,
  isLoading: false,
  loading: false,
  updating: false,
  creating: false,
};

const companyClients = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COMPANY_CLIENTS_REQUEST:
      return { ...state, isLoading: true };
    case types.GET_COMPANY_CLIENTS_RESPONSE:
      return {
        ...state,
        isLoading: false,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    case types.GET_COMPANY_CLIENT_REQUEST:
      return { ...state, loading: true };
    case types.GET_COMPANY_CLIENT_RESPONSE:
      return {
        ...state,
        loading: false,
        current: action.payload,
      };
    case types.CLEAR_COMPANY_CLIENT:
      return { ...state, current: null, loading: false };
    case types.UPDATE_COMPANY_CLIENT_REQUEST:
      return { ...state, updating: true };
    case types.UPDATE_COMPANY_CLIENT_RESPONSE:
      return {
        ...state,
        updating: false,
        current: action.payload ?? state.current,
      };
    case types.CREATE_COMPANY_CLIENT_REQUEST:
      return { ...state, creating: true };
    case types.CREATE_COMPANY_CLIENT_SUCCESS:
    case types.CREATE_COMPANY_CLIENT_FAILURE:
      return { ...state, creating: false };
    default:
      return state;
  }
};

export default companyClients;
